export interface MastLink {
  to: string;
  label: string;
  /** Match the path exactly, for a section's index tab. */
  end?: boolean;
}

/** The AI section: the joined impact view and the raw spend detail. */
export const AI_LINKS: MastLink[] = [
  { to: "/ai-impact", label: "Impact" },
  { to: "/ai-usage", label: "Spend detail" },
];
